import { useLanguage } from '../../contexts/LanguageContext';
import { formatTrendSummary } from '../../utils/metricDiagnosticCandidates';
import { Icons } from '../Icons';

export default function MetricTrendNotices({ history, trends = [], onDiagnose }) {
  const { language } = useLanguage();
  const cs = language === 'cs';
  if (!history || history.status === 'idle') return null;
  return (
    <aside aria-label={cs ? 'Vývoj metrik' : 'Metric trends'} className="rounded-xl border border-slate-700 bg-slate-800/50 p-4 mb-4">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-200">
        <Icons.Activity size={16} className="text-cyan-400" />
        {cs ? 'Vývoj metrik · CrUX origin' : 'Metric trends · CrUX origin'}
      </h3>
      {history.status === 'loading' ? (
        <div role="status" className="mt-3 space-y-2">
          <div className="skeleton h-3 w-3/4 rounded" />
          <p className="text-xs text-slate-400">{cs ? 'Načítám podklady pro trend…' : 'Loading trend evidence…'}</p>
        </div>
      ) : history.status === 'error' ? (
        <div role="status" className="mt-2 text-sm text-amber-400">
          {cs ? 'Historii nelze načíst. Trend není vyhodnocen.' : 'History unavailable. Trends have not been assessed.'}
          <button type="button" onClick={history.retry} className="ml-3 underline underline-offset-4">
            {cs ? 'Zkusit znovu' : 'Retry'}
          </button>
        </div>
      ) : trends.length ? (
        <ul className="mt-3 space-y-3">
          {trends.map(item => (
            <li key={`${item.metric}:${item.device}`} className="flex flex-col gap-2 border-t border-slate-700 pt-3 sm:flex-row sm:items-start sm:justify-between">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-amber-400">
                  {item.metric} · {item.device === 'PHONE' ? (cs ? 'Mobil' : 'Mobile') : item.device === 'TABLET' ? 'Tablet' : 'Desktop'}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-slate-400">{formatTrendSummary(item, language)}</p>
              </div>
              {onDiagnose && <button type="button" onClick={() => onDiagnose(item)} className="shrink-0 rounded-lg border border-cyan-500/40 bg-cyan-500/10 px-3 py-2 text-xs font-semibold text-cyan-400">
                {cs ? 'Diagnostikovat' : 'Diagnose'}
              </button>}
            </li>
          ))}
        </ul>
      ) : (
        <p role="status" className="mt-2 text-xs leading-relaxed text-slate-400">
          {cs
            ? 'V dostupných podkladech není doloženo zhoršování. Chybějící nebo nedostatečná srovnatelná historie není důkazem stability. CrUX používá překrývající se 28denní okna.'
            : 'No deterioration is established by the available evidence. Missing or insufficient comparable history is not proof of stability. CrUX uses overlapping 28-day windows.'}
        </p>
      )}
    </aside>
  );
}
